import { getFullName } from '@/shared/lib'
import { AlertDialog } from '@/shared/ui'
import { Chip } from '@/shared/ui/elements/Chip'
import { toast } from 'react-toastify'
import styled from 'styled-components'
import { useUpdateUserMutation } from '../api/userAdminApi'
import { StatusName, type UserListItemDTO } from '../model/types'

interface Props {
	user: UserListItemDTO
}

const StyledChip = styled(Chip)`
	p {
		text-transform: capitalize;
	}
`

export const UserStatusChip = ({ user }: Props) => {
	let color: 'primary' | 'success' | 'warning' | 'error' = 'primary'

	const userId = user.id
	const status = user.status
	const userName = getFullName(user.firstName, user.lastName)

	const [updateUser] = useUpdateUserMutation({
		// fixedCacheKey: 'shared-delete-user'
	})

	const handleUpdateUserStatus = () => {
		updateUser({
			userId,
			status:
				status === StatusName.ACTIVE ? StatusName.INACTIVE : StatusName.ACTIVE
		})
			.unwrap()
			.then(() => {
				toast.success(
					`User has been ${
						status === StatusName.ACTIVE ? 'inactivated' : 'activated'
					} successfully.`
				)
			})
			.catch(() => {
				toast.error('Failed to update user status. Please try again.')
			})
	}

	if (status === StatusName.ACTIVE) color = 'success'
	if (status === StatusName.PENDING) color = 'warning'
	if (status === StatusName.INACTIVE) color = 'error'

	if (status === StatusName.ACTIVE || status === StatusName.INACTIVE) {
		return (
			<AlertDialog
				Trigger={
					<button style={{ border: 0, cursor: 'pointer' }}>
						<StyledChip label={status} color={color} />
					</button>
				}
				title={`${
					status === StatusName.ACTIVE ? 'Inactive' : 'Active'
				} "${userName}"?`}
				description={`Are you sure you want to ${
					status === StatusName.ACTIVE ? 'inactive' : 'active'
				} "${userName}"?`}
				confirmText={`Yes, ${
					status === StatusName.ACTIVE ? 'Inactive' : 'Active'
				}.`}
				cancelText='Cancel'
				confirmAction={() => {
					handleUpdateUserStatus()
				}}
			/>
		)
	}

	return <StyledChip label={status} color={color} />
}
